var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "ethers";
import { parseUnits } from "ethers/lib/utils";
import { getDisplayAssets, VaultAddressMap, } from "../constants/constants";
import { getAssetColor } from "./asset";
import { Connection } from "@solana/web3.js";
import { Vault, vaultUtils } from "@zetamarkets/flex-sdk";
import * as spl from "@solana/spl-token";
export var isVaultFull = function (deposits, cap, decimals) {
    var margin = parseUnits("0.01", decimals);
    return !cap.isZero() && deposits.gte(cap.sub(margin));
};
export var isVaultSupportedOnChain = function (vaultOption, chainId) {
    return VaultAddressMap[vaultOption].chainId === chainId;
};
export var isETHVault = function (vault) {
    return ["rETH-THETA", "rstETH-THETA"].includes(vault);
};
export var getVaultColor = function (vault) {
    return getAssetColor(getDisplayAssets(vault));
};
// earn outer ring feColorMatrix value
export var getEarnVaultFeColorMatrix = function (vault) {
    var displayAsset = getDisplayAssets(vault);
    switch (displayAsset) {
        case "USDC":
            return "0 0 0 0 0.243137 0 0 0 0 0.45098 0 0 0 0 0.768627 0 0 0 0.25 0";
        case "stETH":
            return "0 0 0 0 0.243137 0 0 0 0 0.45098 0 0 0 0 0.768627 0 0 0 0.25 0";
        case "WBTC":
            return "";
        default:
            return "0 0 0 0 0.0862745 0 0 0 0 0.807843 0 0 0 0 0.72549 0 0 0 0.25 0";
    }
};
/*** SOLANA-ONLY UTILS ***/
export var isEqualsToUserAddress = function (userKey, nodeKey) {
    return userKey === null || userKey === void 0 ? void 0 : userKey.equals(nodeKey);
};
export var getUserDepositQueueAmount = function (vault, userKey) {
    var depositNodes = vault.depositQueue.filter(function (node) {
        return node.info.userKey.equals(userKey);
    });
    return depositNodes.reduce(function (acc, node) { return acc.add(BigNumber.from(node.info.amount.toNumber())); }, BigNumber.from(0));
};
export var getUserWithdrawQueueAmount = function (vault, userKey) {
    var withdrawalNodes = vault.withdrawalQueue.filter(function (node) {
        return node.info.userKey.equals(userKey);
    });
    return withdrawalNodes.reduce(function (acc, node) { return acc.add(BigNumber.from(node.info.amount.toNumber())); }, BigNumber.from(0));
};
export var getSOLPricePerShare = function () { return __awaiter(void 0, void 0, void 0, function () {
    var connection, vaultAddress, vaultInfo, vaultUnderlyingTokenAccount, totalBalance, optionVault, redeemableMint, pricePerShare;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                connection = new Connection(process.env.REACT_APP_SOLANA_MAINNET_URI || "");
                vaultAddress = vaultUtils.getVaultAddress("rSOL-THETA")[0];
                vaultInfo = Vault.getVault(vaultAddress);
                return [4 /*yield*/, spl.getAccount(connection, vaultInfo.vaultUnderlyingTokenAccount)];
            case 1:
                vaultUnderlyingTokenAccount = _a.sent();
                totalBalance = Number(vaultUnderlyingTokenAccount.amount);
                if (!(vaultInfo.option !== null)) return [3 /*break*/, 3];
                return [4 /*yield*/, spl.getAccount(connection, vaultInfo.option.vault)];
            case 2:
                optionVault = _a.sent();
                totalBalance += Number(optionVault.amount);
                _a.label = 3;
            case 3: return [4 /*yield*/, spl.getMint(connection, vaultInfo.redeemableMint)];
            case 4:
                redeemableMint = _a.sent();
                pricePerShare = totalBalance / Number(redeemableMint.supply);
                return [2 /*return*/, pricePerShare];
        }
    });
}); };
export var getSOLAmountByShares = function (amount, decimals) { return __awaiter(void 0, void 0, void 0, function () {
    var pricePerShare;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getSOLPricePerShare()];
            case 1:
                pricePerShare = _a.sent();
                return [2 /*return*/, Math.floor((Number(amount) / Number(pricePerShare)) * Math.pow(10, decimals))];
        }
    });
}); };
//# sourceMappingURL=vault.js.map